import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ShareOverride, ShareWrapper } from './share.style';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import MlbNativeWrapper from '@gameday/utils/MlbNativeWrapper';
import useTracking from '@gameday/utils/hooks/useTracking';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
const { mlbBlack } = COLORS;

const getConfig = (trackingConfig, type = '') => {
    return { ...trackingConfig, ...{ activity: (type ? type + ' ' : '') + 'Click' } };
};

const ShareWidget = ({
    openDirection = 'left',
    url = '',
    headline,
    size = 'xs',
    trackingConfig
}) => {
    const [metaDescription, setMetaDescription] = useState('');
    const [nativeShare, setNativeShare] = useState(null);
    const Tracking = useTracking();
    const ariaLabel = useTranslator('app_share', 'Share');

    const onClick = useCallback((e) => {
        const { target, currentTarget } = e;

        const shareClicked = target?.parentNode?.getAttribute('data-type') === 'share';
        const linkClicked = target?.parentNode?.getAttribute('data-type') === 'link';

        if (shareClicked) {
            const hasShareList = !!currentTarget?.querySelector('.share-list');
            Tracking.track.track_click(getConfig(trackingConfig, hasShareList ? 'Close' : 'Open'));
        }

        if (linkClicked) {
            Tracking.track.track_click(getConfig(trackingConfig, 'link'));
        }
    }, [Tracking, trackingConfig]);

    useEffect(() => {
        MlbNativeWrapper.then((results) => {
            const { share } = results;
            setNativeShare({
                share
            });
        });
    }, [MlbNativeWrapper]);

    useEffect(() => {
        setMetaDescription(document?.querySelector('meta[property="og:description"]')?.getAttribute('content') || '');
    }, []);

    const content = useMemo(() => {
        return {
            url,
            headline: headline || metaDescription
        };
    }, [url, headline, metaDescription]);

    const beforeOnClick = useMemo(() => {
        return {
            facebook: () => {
                Tracking.track.track_click(getConfig(trackingConfig, 'Facebook'));
            },
            twitter: () => {
                Tracking.track.track_click(getConfig(trackingConfig, 'Twitter'));
            },
            email: () => {
                Tracking.track.track_click(getConfig(trackingConfig, 'Email'));
            }
        };
    }, [Tracking, trackingConfig]);

    return (
        <ShareWrapper onClick={onClick}>
            <ShareOverride
                $size={size}
                networks={['email', 'link', 'facebook', 'twitter']}
                fill={mlbBlack}
                openDirection={openDirection}
                persistShareIcon
                nativeShare={nativeShare?.share}
                content={content}
                ariaLabel={ariaLabel}
                beforeOnClick={beforeOnClick}
            />
        </ShareWrapper>
    );
};

ShareWidget.propTypes = {
    openDirection: PropTypes.string,
    url: PropTypes.string.isRequired,
    headline: PropTypes.string,
    size: PropTypes.string,
    trackingConfig: PropTypes.object
};

export default ShareWidget;
